export const SITE = {
  businessName: "Arkham Enterprises",
  dba: "Apex Solar and Construction",
  contactEmail: "arkhamenterprises@proton.me",
  phone: "(715) 210-9610",
  serviceArea: "Serving Buffalo County and the Chippewa Valley region",
  hours: "Mon–Fri: 8am–6pm",
  facebookUrl: "https://www.facebook.com/profile.php?id=61590641048935",
};